import React from 'react';
import { Linkedin, Phone, Mail, ExternalLink } from 'lucide-react';
import { siteConfig, contactInfo } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[var(--bg-dark)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Reach Us Here - Center aligned */}
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-6">Reach Us Here</h3>
            <div className="space-y-4 flex flex-col items-center">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <Phone className="w-5 h-5 text-[var(--brand-teal-400)]" />
                <span>{contactInfo.phone}</span>
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
              >
                <Mail className="w-5 h-5 text-[var(--brand-teal-400)]" />
                <span>{contactInfo.email}</span>
              </a>
              <a
                href={siteConfig.linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#0A66C2] hover:bg-[#004182] text-white px-4 py-2.5 rounded-lg font-medium transition-all hover:translate-y-[-2px] mt-2 group"
              >
                <Linkedin className="w-5 h-5" />
                <span>Follow Us on LinkedIn</span>
                <ExternalLink className="w-4 h-4 opacity-60 group-hover:opacity-100 transition-opacity" />
              </a>
            </div>
          </div>

          {/* Meet us @ Bengaluru, India - Center aligned with square map */}
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-6">Meet us @ Bengaluru, India</h3>
            <a
              href={contactInfo.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-xl overflow-hidden w-48 h-48 mx-auto bg-gray-800 relative group"
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.4714752753!2d77.6133329!3d12.9160056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae153359368a11%3A0x9e90b641d18c84ae!2sGaruda%20BHIVE%20Workspace%20BTM%20Layout%20Campus!5e0!3m2!1sen!2sin!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Office Location"
                className="pointer-events-none"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-white text-gray-800 px-3 py-1.5 rounded-full text-sm font-medium flex items-center gap-2">
                  <ExternalLink className="w-4 h-4" /> Open in Maps
                </span>
              </div>
            </a>
          </div>

          {/* Schedule Demo - Center aligned */}
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-6">Schedule a Demo</h3>
            <p className="text-gray-300 text-sm mb-5 max-w-xs mx-auto">
              See SuperHunt in action. Book a personalized walkthrough with our team.
            </p>
            <a
              href={siteConfig.calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[var(--brand-teal-500)] hover:bg-[var(--brand-teal-400)] text-white px-6 py-3 rounded-full font-medium transition-all hover:translate-y-[-2px] hover:shadow-lg"
            >
              Book Your Demo
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center sm:text-left">
              © {new Date().getFullYear()} Workstreets Internet Technology Pvt Ltd. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              A product of <span className="text-[var(--brand-teal-400)]">Workstreets.io</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
